import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

const SeoPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    fetch(`${API}/?url=seo/page/${slug}&_t=${Date.now()}`)
      .then((r) => {
        if (r.status === 404) { setNotFound(true); return null; }
        return r.json();
      })
      .then((data) => { if (data) setPage(data); });
  }, [slug]);

  if (notFound) {
    return (
      <div className="container py-5 text-center">
        <h2>Page Not Found</h2>
        <Link to="/" className="btn btn-dark mt-3">Back to Home</Link>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-secondary" />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{page.meta_title || page.title}</title>
        <meta name="description" content={page.meta_description} />
        {page.keywords && <meta name="keywords" content={page.keywords} />}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        {page.canonical_url && <link rel="canonical" href={page.canonical_url} />}
        <meta property="og:title" content={page.meta_title || page.title} />
        <meta property="og:description" content={page.meta_description} />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home",        "item": "https://www.clearandclean.co.nz/" },
            { "@type": "ListItem", "position": 2, "name": page.title,    "item": `https://www.clearandclean.co.nz/${slug}` }
          ]
        })}</script>
      </Helmet>

      {/* Hero */}
      <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: 'url("/images/service_2.jpg")' }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 ftco-animate pb-5">
              <p className="breadcrumbs mb-2">
                <span className="mr-2">
                  <Link to="/">Home <i className="fa fa-chevron-right" /></Link>
                </span>
                <span>{page.title} <i className="fa fa-chevron-right" /></span>
              </p>
              <h1 className="mb-0 bread">{page.h1 || page.title}</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              {page.content ? (
                <div
                  className="seo-page-content"
                  dangerouslySetInnerHTML={{ __html: page.content }}
                />
              ) : (
                <div className="text-center py-5">
                  <p className="lead text-muted">
                    Clear & Clean provides professional {page.title} services across Christchurch and Canterbury.
                  </p>
                  <Link to="/contact" className="btn btn-dark mt-3">Get a Free Quote</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SeoPage;
